import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSignalQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type GetSignalQuery = {
  __typename?: 'Query';
  signal?: {
    __typename?: 'Signal';
    id: any;
    name: string;
    description: string;
    signalType: Types.SignalType;
    createdAt: any;
    updatedAt: any;
    fingerprints: Array<
      | {
          __typename?: 'BlockFingerprint';
          operation: Types.ConditionOperator;
          blockField: string;
          value: {
            __typename?: 'FingerprintValue';
            valueType: Types.FingerprintValueType;
            value: any;
          };
        }
      | {
          __typename?: 'LogFingerprint';
          operation: Types.ConditionOperator;
          logField: Types.LogField;
          value: {
            __typename?: 'FingerprintValue';
            valueType: Types.FingerprintValueType;
            value: any;
          };
        }
      | {
          __typename?: 'TransactionFingerprint';
          operation: Types.ConditionOperator;
          transactionField: Types.TransactionField;
          value: {
            __typename?: 'FingerprintValue';
            valueType: Types.FingerprintValueType;
            value: any;
          };
        }
    >;
    triggers: {
      __typename?: 'SignalTriggerConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'SignalTriggerEdge';
        node: {
          __typename?: 'SignalTrigger';
          id: any;
          triggeredAt: any;
          transaction?: {
            __typename?: 'Transaction';
            hash: string;
            blockNumber?: number | null;
            value: Array<number>;
            from: { __typename?: 'Address'; address: string };
            to?: { __typename?: 'Address'; address: string } | null;
          } | null;
        };
      }>;
    };
  } | null;
};

export const GetSignalDocument = gql`
  query GetSignal($id: UUID!) {
    signal(id: $id) {
      id
      name
      description
      signalType
      createdAt
      updatedAt
      fingerprints {
        ... on BlockFingerprint {
          blockField: field
          operation
          value {
            valueType
            value
          }
        }
        ... on TransactionFingerprint {
          transactionField: field
          operation
          value {
            valueType
            value
          }
        }
        ... on LogFingerprint {
          logField: field
          operation
          value {
            valueType
            value
          }
        }
      }
      triggers(first: 5) {
        totalCount
        edges {
          node {
            id
            triggeredAt
            transaction {
              hash
              blockNumber
              from {
                address
              }
              to {
                address
              }
              value
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetSignalQuery__
 *
 * To run a query within a React component, call `useGetSignalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSignalQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSignalQuery,
    GetSignalQueryVariables
  > &
    (
      | { variables: GetSignalQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSignalQuery, GetSignalQueryVariables>(
    GetSignalDocument,
    options,
  );
}
export function useGetSignalLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSignalQuery,
    GetSignalQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSignalQuery, GetSignalQueryVariables>(
    GetSignalDocument,
    options,
  );
}
export function useGetSignalSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSignalQuery, GetSignalQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSignalQuery, GetSignalQueryVariables>(
    GetSignalDocument,
    options,
  );
}
export type GetSignalQueryHookResult = ReturnType<typeof useGetSignalQuery>;
export type GetSignalLazyQueryHookResult = ReturnType<
  typeof useGetSignalLazyQuery
>;
export type GetSignalSuspenseQueryHookResult = ReturnType<
  typeof useGetSignalSuspenseQuery
>;
export type GetSignalQueryResult = Apollo.QueryResult<
  GetSignalQuery,
  GetSignalQueryVariables
>;
